export type StoryQueryKey = readonly unknown[];

export const STORY_QUERY_ROOT = 'story-server-state' as const;

export const storyQueryScope = (domain: string, ...identity: readonly unknown[]): StoryQueryKey =>
  Object.freeze([STORY_QUERY_ROOT, domain, ...identity]);
